import { create } from 'zustand';

const useActionsCapabilitiesStore = create((set) => ({
  // Video generation info
  videoGenerationInfo: false,
  // Flag to show the actions capabilities
  generationsModelsActive: false,
  setGenerationsModelsActive: (generationsModelsActive) =>
    set({ generationsModelsActive }),
  // Model selected
  selectedModel: null,
  setSelectedModel: (selectedModel) => {
    return set({
      selectedModel,
      // Automatically update videoGenerationInfo based on model type
      videoGenerationInfo: selectedModel?.type === 'video',
    });
  },
  selectedModelParameters: null,
  setSelectedModelParameters: (selectedModelParameters) =>
    set({ selectedModelParameters }),
}));

export default useActionsCapabilitiesStore;
